import { requestApi } from '@app/api';
import { withForm } from '@app/api/paths';

interface GetDraftRolesParams {
  limit: number;
  offset: number;
  subjects: (`MEMBER/${string}` | `GROUP/${string}`)[];
}
interface GetDraftRolesResponse {
  count: number;
  roles: {
    id: string;
    workspaceId: string;
    draftId: string;
    subjectType: 'MEMBER' | 'GROUP';
    member?: {
      id: string;
      name: string;
      description: string;
      userId: string;
      userName: string;
      userEmail: string;
    };
    group?: { id: string; name: string; type: 'ALL_MEMBERS' | 'CUSTOM'; description: string };
    name: 'VIEWER' | 'EDITOR';
    createdAt: string;
    updatedAt: string;
  }[];
}
export function getDraftRoles(
  workspaceId: string,
  draftId: string,
  { subjects, ...params }: GetDraftRolesParams
): Promise<GetDraftRolesResponse> {
  return requestApi<GetDraftRolesResponse>({
    url: withForm(`/workspaces/${workspaceId}/drafts/${draftId}/roles`),
    method: 'GET',
    credentials: true,
    params: { ...params, filter: { subjects } },
  }).then((response) => response.data);
}
